export const RequiredScopes = 'requiredScopes';
